<template>
  <div class="bookmaster-wraper">
    <app-modal-confirm
      ref="apikey_modal_delete"
      :modal-header-title="$t('common_vn.delete confirm title')"
      @confirmed="deleteApiKey()"
    >
      <template v-slot:body>
        <p class="confirm-body">{{ $t("common_vn.delete confirm") }}</p>
      </template>
    </app-modal-confirm>

    <app-modal-confirm
      ref="cate_menu_modal_delete"
      :modal-header-title="$t('common_vn.delete confirm title')"
      @confirmed="deleteCateMenu()"
    >
      <template v-slot:body>
        <p class="confirm-body">{{ $t("common_vn.delete confirm") }}</p>
      </template>
    </app-modal-confirm>

    <validation-observer
      ref="form_create_entry"
      v-slot="{ passes, valid, validated }"
    >

      <form class="form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card card-body">
              <template v-if="idEditing">
                <div class="form-group row">
                  <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("common.id") }}</label>
                  <label class="col-xl-1 col-lg-2 col-sm-2 m-t-8">{{ entry.id }}</label>
                </div>
              </template>

              <!-- category name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.name") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_category_menu_name"
                    type="string128"
                    rules="required"
                    v-model="entry.name"
                  />
                </div>
              </div>

              <!-- category name vn -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.name_vn") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_category_menu_name_vn"
                    type="string128"
                    rules="required"
                    v-model="entry.name_vn"
                  />
                </div>
              </div>

              <!-- restaurant name vn -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("restaurant.name") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-select
                    name="restaurant_name"
                    rules="required"
                    :options-data="restaurantList"
                    v-model="entry.restaurant_id"
                  />
                </div>
              </div>

              <!-- Category name -->
              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category.name_other") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-select
                    name="kyy_category_name"
                    rules="required"
                    :options-data="categoryList"
                    v-model="entry.category_id"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.price") }} <span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-input
                    name="kyy_category_menu_price"
                    type="number-length:9"
                    rules="required|min_value:1"
                    v-model="entry.price"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.description") }}</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-textarea
                    name="kyy_menu_description"
                    type="string128"
                    v-model="entry.description"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.description_vn") }}</label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-textarea
                    name="kyy_menu_description_vn"
                    type="string128"
                    v-model="entry.description_vn"
                  />
                </div>
              </div>

              <!-- image -->
              <validation-provider
                name="kyy_category_menu_image"
                rules="required"
                v-slot="{ errors, invalid, validated }"
              >
              <div class="form-group row ">
                <label class="col-xl-1 col-lg-2 col-sm-2 col-form-label">{{ $t("category_menu.image") }}<span class="app-require">＊</span></label>
                <div class="col-xl-5 col-lg-8 col-sm-8">
                  <app-single-file-input accept="image/jpeg, image/png, image/jpg" 
                    name="kyy_category_menu_image"
                    :imageSrc="entry.image_path"
                    @input="handlerUploadImage"
                    @updated_at="entry.data_updated_at = $event"
                    :id-editing="idEditing"
                    rules="required"
                    v-model="entry.image"
                    :allowedExtension="allowedExtension" >
                  </app-single-file-input>
                  <label class="error">
                    {{ errors[0] }}
                  </label>
                </div>
              </div>
              </validation-provider>

              <div class="card-footer row justify-content-end">
                <button type="button" :disabled="!valid && validated" class="btn btn-default m-r-10" @click="confirmCancel">
                  {{ $t('common_vn.cancel') }}
                </button>
                <button v-if="idEditing" type="button" :disabled="!valid && validated" class="btn btn-danger m-r-10" @click="handleDelete">
                  {{ $t('common_vn.delete') }}
                </button>
                <button v-if="idEditing" :disabled="!valid && validated" class="btn btn-primary m-r-10" @click="createOrUpdate" type="button">
                  {{  $t('common_vn.save') }}
                </button>
                <button v-else :disabled="!valid && validated" class="btn btn-primary m-r-10" type="button" @click="createOrUpdate" >
                  {{  $t('common_vn.create') }}
                </button>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import AppTextarea from "../../../components/forms/AppTextarea";
import AppDateRangePicker from "../../../components/forms/AppDateRangepicker";
import {ROUTES} from "@constants";
export default {
  name: "CategoryMenuCreateOrEdit",

  components: {
    AppTextarea,
    AppDateRangePicker,
  },

  data() {
    const id = this.$route.params.id
    return {
      entry: {
        id: null,
        name: '',
        name_vn: '',
        restaurant_id: null,
        category_id: null,
        price: '',
        description: '',
        description_vn: '',
        image_path: null,
        image: null,
        data_updated_at: null,
        image_updated_at: null
      },
      categoryList: [],
      restaurantList: [],
      apiKeyId: null,
      idEditing: id,
      entryNameUpdate: "",
      startValidate : !!id,
      allowedExtension : ['image/jpeg', 'image/png', 'image/jpg']
    };
  },
  watch : {
    "entry.restaurant_id" : async function(value) {
      if (value) {
        let filters = {
          'filters[restaurant_id][equal]': value
        }

        let responseForCategory = await this.$request.get(this.ENDPOINT.KYY_CATEGORY_LIST_SELECT, filters);
        if (responseForCategory.hasErrors()) {
          if (responseForCategory.status === 'error'){
            this.__noticeError(this.$t(responseForCategory.data.error_msg));
          }
          this.categoryList = [];
          this.entry.category_id = null;
        } else {
          this.categoryList = responseForCategory.data.data.map(item => {
            return {
              id: item.id,
              name: item.name
            }
          });
          if (!this.startValidate) {
            this.entry.category_id = null;
          }
        }
      }
    },
  },

  mounted: async function () {
    // call api get list restaurant
    let response = await this.$request.get(this.ENDPOINT.KYY_RESTAURANT_LIST_SELECT);
    if (response.hasErrors()) {
      if (response.status === 'error'){
        this.__noticeError(this.$t(response.data.error_msg));
      }
    } else {
      this.restaurantList = response.data.data.map(item => {
        return {
          id: item.id,
          name: item.name
        }
      });
    }
    if (this.idEditing) {
      this.startValidate = false;
      let response = await this.$request.get(this.ENDPOINT.KYY_CATEGORY_MENU_EDIT(this.idEditing));
      if (response.hasErrors()) {
        if (response.status === 'error'){
          this.__noticeError(this.$t(response.data.error_msg));
        }
        await this.redirectDefaultValue()
      } else {
        this.entry = _.cloneDeep(response.data.data);
        this.entry.category_id = this.entry.kyy_category_id;
        this.entry.description_vn = this.entry.description_vn;
        this.entry.image_path = this.entry.image.url;
        this.entry.image_updated_at = this.entry.image.updated_at;
        this.startValidate = true;
      }
    }
  },

  methods: {
    handlerUploadImage(data) {
      this.entry.image = data
      this.entry.image_path = data
      this.entry.image_updated_at = new Date().getTime()
    },
    confirmCancel()
    {
      if(this.$store.state.setting.prevRouter.name === ROUTES.ADMIN.KYY_CATEGORY_MENU_LIST) {
        this.__redirectBack()
      } else {
        this.redirectDefaultValue()
      }
    },
    async createOrUpdate() {
      this.startValidate = true;
      console.log(await this.$refs.form_create_entry.validate())
      if (!await this.$refs.form_create_entry.validate()) {
        return;
      }
      let res = null;
      let msg = "";
      let params = _.cloneDeep(this.entry);
      if (this.idEditing) {
        res = await this.$request.patch(this.ENDPOINT.KYY_CATEGORY_MENU_EDIT(this.idEditing), params);
        msg = this.$t("common.msg update ok")
      } else {
        res = await this.$request.post(this.ENDPOINT.KYY_CATEGORY_MENU_CREATE, params);
        msg = this.$t("common.msg create ok")
      }
      if (res.hasErrors()) {
        this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
      } else {
        this.__noticeSuccess(msg);
        await this.redirectDefaultValue();
      }
    },

    async redirectDefaultValue() {
      await this.$router.push({
        name: this.ROUTES.ADMIN.KYY_CATEGORY_MENU_LIST, query: {}
      });
    },
    handleDelete() {
      this.$refs.cate_menu_modal_delete.show();
    },
    async deleteCateMenu() {
      const res = await this.$request.delete(this.ENDPOINT.KYY_CATEGORY_MENU_DELETE(this.idEditing));
      if (!res.hasErrors()) {
        this.__noticeSuccess(this.$t("common.msg delete ok"));
        await this.redirectDefaultValue();
      } else {
        this.__noticeError(res.data.error_msg != undefined ? res.data.error_msg : this.$t('common.error'));
        this.$refs.cate_menu_modal_delete.hide();
      }
    },
  },
};
</script>
<style>
@media (min-width: 1200px) {
  .col-unit {
    flex: 0 0 14%;
  }
}

</style>
